import { Component, OnInit } from '@angular/core';
import { QrConfigTableService } from './qr-config-table.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-qr-config-table',
  templateUrl: './qr-config-table.component.html',
  styleUrls: ['./qr-config-table.component.sass']
})
export class QrConfigTableComponent implements OnInit {
allQrConfig:any;
  constructor( private qrConfigTableServices:QrConfigTableService,
               private toaster: ToastrService,
               private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.qrConfigTable()
  }
   qrConfigTable(): void {
    this.spinner.show(); 
    let data:{}
    this.qrConfigTableServices.qrConfigTable(data).subscribe((result: any) => {
      if (result.statusCode === 200) {
        this.spinner.hide()
        // this.toaster.success(result.message)
        this.allQrConfig=result.data
        console.log(result.data);
      } else {
        this.toaster.error(result.message)
      }
    }, error => {
      console.error('Error:', error);
    });
  }


}
